import { cn } from "@/shared/lib/cn";

/**
 * Three loose cards on a soft sage halo: the picture behind every empty state. Drawn only with
 * colour tokens, so it follows the light and dark themes. Decorative; mirrored in Arabic.
 */
export function EmptyIllustration({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 160 112"
      fill="none"
      aria-hidden="true"
      className={cn("h-auto rtl:-scale-x-100", className)}
    >
      <ellipse cx="80" cy="62" rx="70" ry="46" className="fill-brand-soft" />
      <ellipse cx="80" cy="62" rx="52" ry="34" className="fill-surface" fillOpacity="0.55" />

      <g transform="rotate(-8 50 58)">
        <rect
          x="20"
          y="34"
          width="60"
          height="46"
          rx="9"
          className="fill-surface-sunken stroke-line"
        />
        <rect x="30" y="46" width="24" height="4" rx="2" className="fill-line-strong" />
        <rect x="30" y="56" width="36" height="4" rx="2" className="fill-surface-hover" />
      </g>

      <g transform="rotate(7 112 52)">
        <rect x="82" y="26" width="60" height="46" rx="9" className="fill-surface stroke-line" />
        <rect x="92" y="38" width="20" height="4" rx="2" className="fill-brand" opacity="0.55" />
        <rect x="92" y="48" width="38" height="4" rx="2" className="fill-surface-hover" />
        <rect x="92" y="56" width="28" height="4" rx="2" className="fill-surface-hover" />
      </g>

      <rect
        x="44"
        y="40"
        width="72"
        height="56"
        rx="10"
        className="fill-surface stroke-line-strong"
      />
      <circle cx="58" cy="55" r="5.5" className="fill-tone-1" />
      <rect x="69" y="51" width="32" height="4" rx="2" className="fill-line-strong" />
      <rect x="69" y="59" width="20" height="3" rx="1.5" className="fill-surface-hover" />
      <rect x="54" y="71" width="48" height="4" rx="2" className="fill-surface-hover" />
      <rect x="54" y="80" width="34" height="4" rx="2" className="fill-surface-hover" />

      <circle cx="18" cy="26" r="2.5" className="fill-brand" opacity="0.45" />
      <circle cx="146" cy="90" r="2" className="fill-brand" opacity="0.4" />
      <path
        d="M140 14v8M136 18h8"
        strokeWidth="1.6"
        strokeLinecap="round"
        className="stroke-brand"
        opacity="0.6"
      />
    </svg>
  );
}
